import { useMutation } from '@apollo/client';
import { Box, IconSize, SecondaryButton, Spinner } from '@lifechurch/react-ion';
import React from 'react';
import { useTheme } from 'styled-components';
import { AlertType, useAlertContext } from '@lib/alertContext';
import { Metrics } from '@lib/metrics';
import { EXPORT_USERS } from '@lib/queries';
import { ExportUsersMutation } from '@generated/types';
import { useTranslation } from 'react-i18next';

const ExportUsersButton: React.FC = () => {
  const { openAlert } = useAlertContext();
  const { t } = useTranslation('users');

  const handleError = (): void => {
    openAlert(AlertType.ERROR, `An error occurred.`);
  };

  const [exportUsers, { loading }] = useMutation<ExportUsersMutation>(EXPORT_USERS, {
    onCompleted: data => {
      if (data.exportUsers?.downloadUrl) {
        Metrics.usersExported();
        window.open(data.exportUsers?.downloadUrl);
      } else {
        handleError();
      }
    },
    onError: () => {
      handleError();
    },
  });

  const handleExport = (): void => {
    exportUsers();
  };

  const theme = useTheme();

  return (
    <SecondaryButton
      marginInlineStart='auto'
      marginInlineEnd={5}
      onClick={handleExport}
      disabled={loading}
    >
      {loading ? (
        <Box px={7}>
          <Spinner size={IconSize.SM} color={theme.colors.gray50} />
        </Box>
      ) : (
        t('export_users')
      )}
    </SecondaryButton>
  );
};

export default ExportUsersButton;
